import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { CrmShellProviders } from './providers/CrmShellProviders';
import AppErrorBoundary from '@crm/components/AppErrorBoundary';
import 'antd/dist/antd.css';

const rootEl = document.getElementById('root');

if (!rootEl) {
  document.body.innerHTML =
    '<div style="padding:24px;font-family:Inter,sans-serif">Root element #root not found.</div>';
} else {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <AppErrorBoundary scope="CCC">
        <BrowserRouter>
          <CrmShellProviders>
            <App />
          </CrmShellProviders>
        </BrowserRouter>
      </AppErrorBoundary>
    </React.StrictMode>
  );
}
